var exports = {
  "uW": "section__mI3I3S",
  "Kk": "icon__i5D4L6",
  "h_": "description__aX8bfG",
};

module.exports = exports;
